import { DefaultLayout } from '~/Layout';
import { Home, Dashboard, Statistics } from '~/pages/Home';
import { Login } from '~/pages/Account';
import { Report, Recharge, Withdraw, BetHistory } from '~/pages/Report';
import { Refund } from '~/pages/Refund';
import Profile from '~/pages/Account/Profile';
import HistoryGiftCode from '~/pages/HistoryGiftCode';
import HistoryChangeWallet from '~/pages/HistoryChangeWallet';
const routes = [
  {
    path: '/',
    component: Dashboard,
    layout: DefaultLayout,
    title: 'Trang chủ',
  },
  {
    path: '/report',
    component: Report,
    layout: DefaultLayout,
    title: 'Báo cáo đại lý',
  },
  {
    path: '/report/bet-history',
    component: BetHistory,
    layout: DefaultLayout,
    title: 'Báo cáo đại lý',
  },
  {
    path: '/recharge',
    component: Recharge,
    layout: DefaultLayout,
    title: 'Lịch sử nạp tiền',
  },
  {
    path: '/withdraw',
    component: Withdraw,
    layout: DefaultLayout,
    title: 'Lịch sử rút tiền',
  },
  {
    path: '/statistics',
    component: Statistics,
    layout: DefaultLayout,
    title: 'Trang chủ',
  },
  {
    path: '/refund',
    component: Refund,
    layout: DefaultLayout,
    title: 'Hoàn trả',
  },
  {
    path: '/history-giftcode',
    component: HistoryGiftCode,
    layout: DefaultLayout,
    title: 'Lịch sử Gift Code',
  },
  // {
  //   path: "/history-change-wallet",
  //   component: HistoryChangeWallet,
  //   layout: DefaultLayout,
  //   title: "Lịch sử chỉnh ví",
  // },
  {
    path: '/account/profile',
    component: Profile,
    layout: DefaultLayout,
    title: 'Thông tin cá nhân',
  },
  {
    path: '/account/login',
    component: Login,
    layout: null,
    title: 'Đăng nhập',
  },
];

export default routes;
